export const MESSAGE_TYPE_ERROR = 'Error';
export const MESSAGE_TYPE_SUCCESS = 'Success';
export const MESSAGE_TYPE_WARNING = 'Warning';

export const SET_GLOBAL_MESSAGE = 'SET_GLOBAL_MESSAGE';
export const RESET_GLOBAL_MESSAGE = 'RESET_GLOBAL_MESSAGE';


export const RESET_GENERAL_REDUCER = 'RESET_GENERAL_REDUCER';